<template>
  <div class="flex justify-center px-4 flex-wrap">
    <component
      :is="getComponent(index)"
      v-for="(step, index) in steps"
      :key="step.text"
      class="o-caption flex ml-1 transition-colors ease-in duration-200"
      :class="{ 'text-neutral-400': isNotActive(index), 'hover:text-women-text-hover': !isNotActive(index) }"
      :to="{ path: step.link }"
    >
      <template v-if="!isEmptyStep(step)">
        <OSvg v-if="index !== 0" class="w-2 mr-1 fill-current" svg="new-chevron-right" />
        {{ step.text }}
      </template>
    </component>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'WomenProgressSteps',
  components: { OSvg },
  props: {
    steps: {
      type: Array,
      default: () => ([
        {
          link: '',
          text: 'Size'
        },
        {
          link: '',
          text: 'Free set'
        },
        {
          link: '',
          text: 'Account'
        },
        {
          link: '',
          text: 'Shipping'
        },
        {
          link: '',
          text: 'Confirmation'
        }
      ])
    },
    activeIndex: {
      type: Number,
      default: 1
    },
    disableLinks: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isNotActive (index) {
      return (index + 1) > this.activeIndex
    },
    getComponent (index) {
      if (this.disableLinks) {
        return 'span'
      }

      return this.isNotActive(index) ? 'span' : 'nuxt-link'
    },
    isEmptyStep (step) {
      return !step.link && !step.text
    }
  }
}
</script>
